var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"loader-box-wrapper pa-2",class:{ 'absolute': _vm.absolute },attrs:{"flat":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":40,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }